export enum CordialEventType {
  ReturnTracking = "Return Tracking",
  ReturnCreated = "Return Created",
  ReturnCreatedItem = "Return Created Item",
}
